import { cn } from "@/lib/utils";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "bg-bank-surface-3/80 animate-pulse rounded select-none",
        className,
      )}
      {...props}
    />
  );
}

/** Pre-composed Skeleton Stat Card matching the Stat component */
export function SkeletonStat() {
  return (
    <div className="border-bank-border bg-bank-surface flex flex-col justify-between rounded-lg border p-3.5 shadow-2xs">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="size-2 rounded-full" />
      </div>
      <div className="mt-3">
        <Skeleton className="h-7 w-24" />
      </div>
      <div className="mt-2">
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  );
}

/** Skeleton for table row */
export function SkeletonTableRow({ columns }: { columns: (string | undefined)[] }) {
  return (
    <tr className="border-bank-border border-t">
      {columns.map((colWidth, idx) => (
        <td key={idx} className="px-3 py-3">
          <Skeleton className={cn("h-4", colWidth ?? "w-full")} />
        </td>
      ))}
    </tr>
  );
}
